<template>
    <div>
        <v-form>
            <div class="grid">
                <FormTextarea fieldName="to"
                              :label="`${__('To')} (${countTo})`"
                              rows="7"
                              :isFormDisabled="false"
                              v-model:field="to" />
            </div>
            <div class="grid">
                <FormTextarea fieldName="cc"
                              :label="`${__('Cc')} (${countCc})`"
                              rows="1"
                              :isFormDisabled="false"
                              v-model:field="cc" />
            </div>
            <div class="grid">
                <FormTextarea fieldName="bcc"
                              :label="`${__('Bcc')} (${countBcc})`"
                              rows="1"
                              :isFormDisabled="false"
                              v-model:field="bcc" />
            </div>

            <div class="grid">
                <FormInputText fieldName="subject"
                               label="Subject"
                               :isFormDisabled="true"
                               v-model:field="subject" />
            </div>
            <div class="grid">
                <FormEditor fieldName="content"
                            label="Body"
                            :isFormDisabled="true"
                            toolbar="none"
                            :editorStyle="{ height: '200px' }"
                            v-model:field="content" />
            </div>

            <div class="grid"
                 style="margin-top:30px">
                <Button severity="secondary"
                        style="margin:0 8px"
                        @click="cancel">
                    <i class="fa-solid fa-ban"
                       style="margin-right:5px;font-size:18px"></i>
                    {{ __('Cancel') }}
                </Button>

                <Button v-if="allowedEvents"
                        severity="primary"
                        style="margin:0 8px"
                        @click="updateAddresses">
                    <i class="fa-solid fa-check"
                       style="margin-right:5px;font-size:18px"></i>
                    {{ __('Update addresses') }}
                </Button>
            </div>
        </v-form>
    </div>
</template>

<script setup>
import { ref, watch, computed } from 'vue'
import Button from 'primevue/button';
import FormInputText from '@crud/FormInputText.vue'
import FormEditor from '@crud/FormEditor.vue'
import FormTextarea from '@crud/FormTextarea.vue'
import { __, getFromRoute, screenMessage, getTimeouts } from '@pages/Helper/utils.js'

// -----------------------------------------------------
const props = defineProps({
    formProps: Object,
})
const isPreviewMailModalOpen = defineModel('isPreviewMailModalOpen')

const subject = ref(null)
const content = ref(null)
const to = ref(null)
const cc = ref(null)
const bcc = ref(null)
const event = ref(null)
const isLoading = ref(false)

const countTo = computed(() => {
    if (!to.value) return 0;
    return to.value.split(',').length;
})

const countCc = computed(() => {
    if (!cc.value) return 0;
    return cc.value.split(',').length;
})

const countBcc = computed(() => {
    if (!bcc.value) return 0;
    return bcc.value.split(',').length;
})

// -----------------------------------------------------

watch(() => props.formProps, (newVal) => {
    if (!newVal) return;

    subject.value = newVal.subject
    content.value = newVal.content
    to.value = newVal.to
    cc.value = newVal.cc
    bcc.value = newVal.bcc
    event.value = newVal.event
}, { immediate: true })

// -----------------------------------------------------

const allowedEvents = computed(() => ['handWelcomeNewWorker'].includes(event.value))

// -----------------------------------------------------

const cancel = () => {
    isPreviewMailModalOpen.value = false
}

// -----------------------------------------------------

const updateAddresses = async () => {
    isLoading.value = true
    const response = await getFromRoute('mailing-update-addresses', {
        to: to.value,
        cc: cc.value,
        bcc: bcc.value,
        event: event.value,
    }, 'post')
    isLoading.value = false

    console.log(response)
    const timeouts = getTimeouts()
    if (response.status == 'success') {
        screenMessage({ message: response.message, title: "Information", type: "info", position: "center", timeout: timeouts.info });
    } else {
        screenMessage({ message: response.message, title: "Information", type: "error", position: "center", timeout: timeouts.error });
    }
}

// -----------------------------------------------------

</script>

<style lang="scss" scoped></style>
